<div class="flex items-center justify-center">
  <ng-container *ngIf="!formOpen">
    <button
      *isAllowed="[ERoleAdminString.Admin, 'reason.create']"
      type="button"
      class="w-80 btn btn--secondary mr-5"
      (click)="formOpen = true"
    >
      Cadastrar Novo
    </button>
  </ng-container>

  <button
    *ngIf="formOpen"
    type="button"
    class="btn btn--secondary px-5 h-9 leading-4 text-center ml-auto"
    (click)="formOpen = false"
  >
    X
  </button>
</div>

<ng-container *ngIf="formOpen">
  <h1 class="text-lg font-bold leading-3">CADASTRAR UM MOTIVO DE ATENDIMENTO</h1>
  <small class="text-xs text-chathams-blue">Insira os dados abaixo para cadastrar</small>

  <form class="flex flex-col gap-5" [formGroup]="formReason">
    <div class="w-full flex flex-col gap-4 md:flex-row">
      <div class="w-full wrapper flex flex-col gap-4 md:flex-row">
        <div class="form-group">
          <label class="block text-gray-700 text-sm font-bold mb-2" for="trading"> Descrição: </label>
          <input type="text" class="form-input" placeholder="Descrição" formControlName="description" />
        </div>

        <div class="form-group">
          <label class="block text-gray-700 text-sm font-bold mb-2" for="trading"> Tipo: </label>
          <ng-select
            notFoundText="Nenhum item encontrado"
            [searchable]="false"
            placeholder="Tipo"
            formControlName="type"
          >
            <ng-option *ngFor="let type of typeOptions" [value]="type">
              {{ type }}
            </ng-option>
          </ng-select>
        </div>

        <div class="form-group" *isAllowed="[ERoleAdminString.Admin]">
          <label class="block text-gray-700 text-sm font-bold mb-2" for="trading"> Parceiro: </label>
          <ng-select
            notFoundText="Nenhum item encontrado"
            [searchable]="false"
            placeholder="Parceiro"
            formControlName="partnerId"
          >
            <ng-option *ngFor="let partner of partners" [value]="partner.id">
              {{ partner.name }}
            </ng-option>
          </ng-select>
        </div>
      </div>
      <div class="w-full wrapper flex flex-col gap-4 md:flex-row">
        <div class="form-group" *ngIf="podeEscolherEmpresa">
          <label class="block text-gray-700 text-sm font-bold mb-2" for="trading"> Empresas: </label>
          <ng-select
            notFoundText="Nenhum item encontrado"
            [items]="companies"
            placeholder="Empresas"
            formControlName="companyIds"
            bindLabel="name"
            bindValue="id"
            [multiple]="true"
          >
          </ng-select>
        </div>
      </div>
    </div>

    <div class="form-group flex items-center justify-center">
      <button
        *isAllowed="[ERoleAdminString.Admin, 'reason.create']"
        (click)="saveReason()"
        class="w-80 h-9 btn btn--secondary"
      >
        + Salvar novo motivo de atendimento
      </button>
    </div>
  </form>
</ng-container>
